/* ============================================================
   PREVENT DAWN PRODUCT-FORM JS
=============================================================== */
if (window.skipDawnProductForm) {
  document
    .querySelectorAll('product-form, form[action="/cart/add"]')
    .forEach((form) => {
      form.addEventListener('submit', (e) => e.preventDefault());
    });
}

document.addEventListener('DOMContentLoaded', () => {
  /* ============================================================
     SWIPER GALLERY
  ============================================================ */
  const mainEl = document.querySelector('.product-gallery__main');
  const thumbsEl = document.querySelector('.product-gallery__thumbs');

  if (mainEl && window.Swiper) {
    let thumbsSwiper = null;

    if (thumbsEl) {
      thumbsSwiper = new Swiper('.product-gallery__thumbs', {
        slidesPerView: 'auto',
        spaceBetween: 12,
        watchSlidesProgress: true,
      });
    }

    new Swiper('.product-gallery__main', {
      slidesPerView: 1,
      spaceBetween: 0,
      effect: 'slide',
      thumbs: thumbsSwiper ? { swiper: thumbsSwiper } : undefined,
    });
  }

  /* ============================================================
     TABS
  ============================================================ */
  const tabButtons = document.querySelectorAll('[data-product-tab]');
  const tabPanels = document.querySelectorAll('[data-product-tab-panel]');

  tabButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const target = btn.getAttribute('data-product-tab');

      // Toggle active state on buttons
      tabButtons.forEach((b) =>
        b.classList.toggle('is-active', b === btn)
      );

      // Toggle active state on panels
      tabPanels.forEach((panel) => {
        const panelKey = panel.getAttribute('data-product-tab-panel');
        panel.classList.toggle('is-active', panelKey === target);
      });
    });
  });

  /* ============================================================
     PACK SELECTOR (PRICES)
  ============================================================ */
  const packButtons = document.querySelectorAll('[data-pack-option]');
  const addBtn = document.querySelector('[data-add-to-cart]');
  const bundleToggle = document.querySelector('[data-bundle-toggle]');

  const priceMainEl = document.querySelector('.product-main-price');
  const compareEl = document.querySelector('.product-compare-price');

  let selectedVariantId = addBtn?.dataset.mainVariantId || null;

  const getPackCount = (title = '') => {
    const t = title.toLowerCase();
    if (t.includes('2')) return 2;
    if (t.includes('3')) return 3;
    return 1;
  };

  function updateUI(variant) {
    if (!variant || !priceMainEl) return;

    const full = variant.price;   // 79, 138, 180 (already dollars)
    const compare = variant.compare; // 89, 178, 267 (already dollars)

    // Main price
    priceMainEl.textContent = '$' + full;

    // Compare-at price (only if higher)
    if (compareEl) {
      if (compare > full) {
        compareEl.style.display = 'inline-block';
        compareEl.textContent = '$' + compare;
      } else {
        compareEl.style.display = 'none';
      }
    }

    // NOTE: we do NOT touch /Pack subtitles here anymore.
    // Liquid is already outputting correct 79/69/60 per variant.
  }

  // Initial load
  const firstBtn =
    document.querySelector(`[data-variant-id="${selectedVariantId}"]`) ||
    packButtons[0];

  if (firstBtn) {
    updateUI({
      id: Number(firstBtn.dataset.variantId),
      price: Number(firstBtn.dataset.price),
      compare: Number(firstBtn.dataset.compare || 0),
      packCount: getPackCount(
        firstBtn.querySelector('.pack-card__title')?.textContent || ''
      ),
    });
  }

  // Click on a pack
  packButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
      const variant = {
        id: Number(btn.dataset.variantId),
        price: Number(btn.dataset.price),
        compare: Number(btn.dataset.compare || 0),
        packCount: getPackCount(
          btn.querySelector('.pack-card__title')?.textContent || ''
        ),
      };

      selectedVariantId = variant.id;
      if (addBtn) {
        addBtn.dataset.mainVariantId = String(variant.id);
      }

      packButtons.forEach((b) => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');

      updateUI(variant);
    });
  });

  /* ============================================================
     ADD TO CART (+ OPTIONAL BUNDLE)
  ============================================================ */
  /* ADD TO CART */
  if (addBtn) {
    addBtn.addEventListener('click', (e) => {
      e.preventDefault();

      const id = Number(addBtn.dataset.mainVariantId);
      if (!id) return;

      const items = [{ id, quantity: 1 }];

      if (bundleToggle?.checked) {
        const bundleId = Number(bundleToggle.dataset.variantId);
        if (bundleId) items.push({ id: bundleId, quantity: 1 });
      }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ items }),
      })
      .then(() => {
        if (window.CustomCart?.openAndRefresh) {
          window.CustomCart.openAndRefresh();
        } else {
          window.location.href = '/cart';
        }
        window.updateHeaderCartBubble(); // <-- Add this line
      });
    });
  }
});
